import { useControls } from 'leva'

export default function WallThickness()
{
    const leva = 
        // useControls('wallThickness', 
        {
            colorLeft:'#89807d',
            colorRight:'#5f5454',
            colorTop:'#baa7a7',
            colorBottom:'#5f5b5b',
        }
        // ,
        // { collapsed: true }
        // )


    return <>

        {/* LEFT */}
        {/* Thickness Left Vertical */}
        <mesh receiveShadow position={[ -2.5, 0, 2 ]}>
            <planeGeometry  args={[ 1, 4 ]} />
            <meshStandardMaterial color={leva.colorLeft} />
        </mesh>

        {/* Thickness Left Bottom */}
        <mesh receiveShadow position={[ -0.5, -2.5, 2 ]}>
            <planeGeometry  args={[ 5, 1 ]} />
            <meshStandardMaterial color={leva.colorLeft} />
        </mesh>

        {/* RIGHT */}
        {/* Thickness Right Vertical */}
        <mesh  position={[ 2, 0, -2.5 ]} rotation-y={ Math.PI * 0.5 }  >
            <planeGeometry  args={[1,4]} />
            <meshStandardMaterial color={leva.colorRight} />
        </mesh>

        {/* Thickness Right Bottom */}
        <mesh  position={[ 2, -2.5, -0.5 ]} rotation-y={ Math.PI * 0.5 }  >
            <planeGeometry  args={[ 5, 1 ]} />
            <meshStandardMaterial color={leva.colorRight} />
        </mesh>

        {/* TOP */}
        {/* Thickness Left Top */}
        <mesh receiveShadow position={[ -2.5, 2, -0.5 ]} rotation-x={ -Math.PI * 0.5 }>
            <planeGeometry  args={[ 1, 5 ]} />
            <meshStandardMaterial color={leva.colorTop} />
        </mesh>

        {/* Thickness Right Top */}
        <mesh receiveShadow position={[ 0, 2, -2.5 ]} rotation-x={ -Math.PI * 0.5 }>
            <planeGeometry  args={[ 4, 1 ]} />
            <meshStandardMaterial color={leva.colorTop} />
        </mesh>

        {/* BACK */}
        {/* Cap Left */}
        <mesh  position={[ -3, -0.5, -0.5 ]} rotation-y={ - Math.PI * 0.5 }  >
            <planeGeometry  args={[5,5]} />
            <meshStandardMaterial color={leva.colorRight} />
        </mesh>

        {/* Cap Right */}
        <mesh  position={[ -0.5, -0.5, -3 ]} rotation-y={ Math.PI }  >
            <planeGeometry  args={[5,5]} />
            <meshStandardMaterial color={leva.colorBottom} />
        </mesh>

        {/* BOTTOM */}
        <mesh  position={[ -0.5, -3, -0.5 ]} rotation-x={ Math.PI * 0.5 }  >
            <planeGeometry  args={[5,5]} />
            <meshStandardMaterial color={leva.colorBottom} />
        </mesh>
        
    </>   
}